import { Button, Select, Space, Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { FilterReportsModal } from "./filterModal";
import { reportFilter } from "./state";
import { apiExcelReport, apiGetReports } from "../../../api/api";

const columnsUnclaimed: ColumnsType<any> = [
  {
    title: "Код заявления",
    dataIndex: "orderId",
  },
  {
    title: "Номер документа",
    dataIndex: "orderNumber",
  },
  {
    title: "Название организации",
    dataIndex: "companyName",
  },
  {
    title: "Название услуги",
    dataIndex: "serviceName",
  },
  {
    title: "Дней просрочки",
    dataIndex: "daysDelay",
  },
];

const columnsReportsWithOneDay: ColumnsType<any> = [
  {
    title: "Код заявления",
    dataIndex: "orderId",
  },
  {
    title: "Номер документа",
    dataIndex: "orderNumber",
  },
  {
    title: "Название организации",
    dataIndex: "companyName",
  },
  {
    title: "Название услуги",
    dataIndex: "serviceName",
  },
];

export const ReportsTable = () => {
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [visibleFilter, setVisibleFilter] = useState<boolean>(false);
  const filter = useRecoilValue(reportFilter);
  const [selectedReport, setSelectedReport] = useState<string | undefined>(
    "reportDelayGetOrderBySupplier"
  );

  const loadReport = async (reportName: string) => {
    setLoading(true);
    try {
      const resp = await apiGetReports(
        reportName,
        filter.companyId,
        filter.serviceId,
        filter.dateBeginFiltered,
        filter.dateEndFiltered
      );
      setDataSource(resp.result);
    } finally {
      setLoading(false);
    }
  };

  const changeReportHandler = (value: string | undefined) => {
    if (!value) return;
    setDataSource([]);
    loadReport(value);
    setSelectedReport(value);
  };

  const downloadReport = async () => {
    if (!selectedReport) return;
    const response = await apiExcelReport(
      selectedReport.charAt(0).toUpperCase() + selectedReport.slice(1)
    );

    const downloadLink = window.document.createElement("a");
    downloadLink.href = window.URL.createObjectURL(response.data);
    const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = fileNameRegex.exec(response.headers["content-disposition"]);
    if (matches && matches[1]) {
      decodeURI(matches[1].replace(/['"]/g, "").replace(/UTF-8/g, ""));
    }
    if (matches && matches[1]) {
      downloadLink.download = decodeURI(
        matches[1].replace(/['"]/g, "").replace(/UTF-8/g, "")
      );
    } else downloadLink.download = "отчёт.xlsx";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    window.URL.revokeObjectURL(downloadLink.href);
    document.body.removeChild(downloadLink);
  };

  useEffect(() => {
    if (selectedReport) loadReport(selectedReport);
  }, [filter]);

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          margin: "10px 20px 0px",
          justifyContent: "space-between",
        }}
      >
        <h1>Отчёты</h1>
        <Space>
          <Select
            className="report-type"
            defaultActiveFirstOption
            defaultValue="reportDelayResult"
            onChange={changeReportHandler}
            disabled={loading}
            style={{ width: 200 }}
          >
            <Select.Option value="reportDelayGetOrderBySupplier">
              Дела с просроченной приёмкой
            </Select.Option>
            <Select.Option value="reportDelayGetOrderBySupplierWillBeTomorrow">
              До просрочки приёмки 1 день
            </Select.Option>
            <Select.Option value="reportDelayResult">
              Дела с просроченным результатом
            </Select.Option>
            <Select.Option value="reportDelayResultWillBeTomorrow">
              До просрочки результата 1 день
            </Select.Option>
          </Select>
          <Button disabled={loading} onClick={() => downloadReport()}>
            Скачать
          </Button>
          <Button
            type="primary"
            onClick={() => setVisibleFilter(true)}
            disabled={loading}
          >
            Найти
          </Button>
        </Space>
      </div>
      <Table
        style={{ margin: 20, marginTop: 10 }}
        loading={loading}
        scroll={{ y: "calc(100vh - 244px" }}
        dataSource={dataSource}
        columns={
          selectedReport === "reportDelayGetOrderBySupplierWillBeTomorrow" ||
          selectedReport === "reportDelayResultWillBeTomorrow"
            ? columnsReportsWithOneDay
            : columnsUnclaimed
        }
      />
      <FilterReportsModal
        isVisible={visibleFilter}
        setVisible={setVisibleFilter}
        filterState={reportFilter}
      />
    </>
  );
};
